import AuthorForm from './author-form';

export default AuthorForm;
